import React, { useEffect, useRef, useState } from 'react'
import CircleLoader from '../Loader/CircleLoader/CircleLoader';

import { RootState } from '../../store';

import { useSelector } from 'react-redux';
import { IForwardRule, IUor } from '../../shared/interfaces';
import abilityBuild from '../../shared/CASL/appAbility';
import { useBoolean } from '@fluentui/react-hooks';
import forwardRulesService from '../../services/forwardRules.service';
import { Selection, CheckboxVisibility, DetailsList, DetailsListLayoutMode, SelectionMode, Text, EventGroup, IRenderFunction, IDetailsHeaderProps, IDetailsListStyles, StickyPositionType, Sticky, IColumn, DetailsHeader, ContextualMenu, IContextualMenuItem, ContextualMenuItemType, TooltipHost, ITooltipHostStyles, TooltipOverflowMode } from '@fluentui/react';
import { Visibility_Type, Visibility_Type_Label } from '../../shared/enums';


const tooltipHostStyles: Partial<ITooltipHostStyles> = {
    root: {
        display: 'inline-block',
        maxWidth: '100%',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap'

    }
};

export interface ForwardRulesTableProps {
    forceTableRefresh?: boolean,
    readOnlyMode?: boolean,
    selectedForwardRule?: IForwardRule,
    forwardRuleSelection: Selection,
    forwardRulesFilter?: Partial<IForwardRule>,
    onSelectForwardRuleHandler?: (forwardRule: IForwardRule | undefined) => void
    loadingForwardRulesTable?: boolean
    updateForwardRuleHandler?: () => void;
    deleteForwardRuleHandler?: () => void;

}

type Props = ForwardRulesTableProps;

const ForwardRulesTable: React.FunctionComponent<Props> = (props) => {
    const selectCurrentAoo = (state: RootState) => state.sessionReducer.currentAoo;
    const currentAoo = useSelector(selectCurrentAoo);

    const selectIsMobile = (state: RootState) => state.sessionReducer.isMobile;
    const isMobile = useSelector(selectIsMobile);

    const [loadingForwardRulesTable, setLoadingForwardRulesTable] = useState<boolean>(false);

    const [tableColumns, setTableColumns] = useState<IColumn[] | undefined>([]);
    const [forwardRulesList, setForwardRulesList] = useState<any[]>([]);

    const [showContextualMenu, setShowContextualMenu] = useState(false);
    const [contextMenuItems, setContextMenuItems] = useState<IContextualMenuItem[] | undefined>([]);
    const [contextMenuPosition, setContextMenuPosition] = useState<any>(undefined);


    const prevForwardRulesFilter = useRef<Partial<IForwardRule> | undefined>(undefined);


    useEffect(() => {
        setColumns();
        if (!props.forwardRulesFilter) {
            getForwardRules();
        }
        else if (prevForwardRulesFilter.current?.fieldInternalValue != props.forwardRulesFilter?.fieldInternalValue) {

            getForwardRules();
            prevForwardRulesFilter.current = { ...props.forwardRulesFilter };

        }
    }, [currentAoo, props.forwardRulesFilter]);


    useEffect(() => {
        setLoadingForwardRulesTable(props.loadingForwardRulesTable!);
    }, [props.loadingForwardRulesTable]);

    useEffect(() => {
        setColumns();
        getForwardRules();
    }, [props.forceTableRefresh]);

    useEffect(() => {
        const events = new EventGroup(undefined);
        events.on(props.forwardRuleSelection, 'change', (ev) => {
            const selectedForwardRule = props.forwardRuleSelection.getSelection()[0] as IForwardRule;
            if (props.onSelectForwardRuleHandler) {
                if (selectedForwardRule) {
                    props.onSelectForwardRuleHandler(selectedForwardRule);
                }
                else if (!selectedForwardRule) {
                    props.onSelectForwardRuleHandler(undefined);
                }
            }
        });

        return () => {
            // Anything in here is fired on component unmount.
            events.dispose();
        }


    }, [forwardRulesList]);


    useEffect(() => {

    }, [props.selectedForwardRule]);



    const getForwardRules = () => {
        if (currentAoo) {
            setLoadingForwardRulesTable(true);
            setForwardRulesList([]);

            let getForwardRules;
            if (props.forwardRulesFilter) {
                getForwardRules = forwardRulesService.getFilteredForwardRulesInAoo(currentAoo.id, props.forwardRulesFilter);
            }
            else {
                getForwardRules = forwardRulesService.getAllForwardRulesInAoo(currentAoo.id);
            }

            getForwardRules
                .then(forwardRules => {

                    setForwardRulesList(forwardRules);

                    setLoadingForwardRulesTable(false);
                })
                .catch(error => {
                    setLoadingForwardRulesTable(false);
                });
        }
    }
    const setColumns = () => {
        const fieldColumns = [

            {
                key: 'fieldInternalName',
                fieldName: 'fieldInternalName',
                name: 'Campo',
                minWidth: 100,
                maxWidth: 200,
                isResizable: true,


            },
            {
                key: 'fieldInternalValue',
                fieldName: 'fieldInternalValue',
                name: 'Valore',
                minWidth: 100,
                maxWidth: 200,
                isResizable: true,
            }];

        const uorAndVisibilityColumns = [

            {
                key: 'uor',
                fieldName: 'uor',
                name: 'Uor',
                minWidth: 100,
                maxWidth: 200,
                isResizable: true,
            },
            {
                key: 'visibilityType',
                fieldName: 'visibilityType',
                name: 'Tipo visibilità',
                minWidth: 100,
                isResizable: true,
            },
        ];
        /// Aggiungo una colonna vuota in coda alla tabella, è necessaria per consentire l'allineamneto tra
        /// l'header e i contenuti della tabella 
        if (isMobile == false) {
            uorAndVisibilityColumns.push(
                {
                    key: 'empty',
                    name: '',
                    fieldName: 'empty',
                    minWidth: 1,
                    maxWidth: 1,
                    isResizable: false
                },

            );
        }
        if (props.forwardRulesFilter) {
            setTableColumns(uorAndVisibilityColumns);
        }
        else {
            setTableColumns([...fieldColumns, ...uorAndVisibilityColumns]);
        }
    }

    const onRenderDetailsHeader = (detailsHeaderProps) => {
        const detailsListHeadrerStyles: Partial<IDetailsListStyles> = {

            root: { boxSizing: 'content-box !important' }

        };
        return (

            <DetailsHeader
                {...detailsHeaderProps}
                styles={detailsListHeadrerStyles}
            />
        );
    }

    const onRenderItemColumn = (item?: IForwardRule, index?: number | undefined, column?) => {
       let displayValue = extractDisplayValueAndColumnContent(item, column);

        return (
            <TooltipHost
                content={displayValue}
                styles={tooltipHostStyles}
                overflowMode={TooltipOverflowMode.Self}
            >
                {displayValue}
            </TooltipHost>
        );
    }

    const extractDisplayValueAndColumnContent = (item: IForwardRule | undefined, column: any) => {
        let displayValue = "-";
        let columnInternalName = column?.fieldName;

        if (item) {

            const fieldContent = item[column.fieldName];
            if (fieldContent) {
                switch (columnInternalName) {
                    case 'uor':
                        const uor = (fieldContent as IUor);
                        displayValue = `${uor.sigla} - ${uor.nome}`;
                        break;
                    case 'visibilityType':
                        const visibilityType = (fieldContent as Visibility_Type);
                        displayValue = `${Visibility_Type_Label.get(visibilityType)}`;
                        break;

                    default:
                        displayValue = fieldContent;
                        break;
                }
            }
        }
        return displayValue;
    }


    // metodi gestione context menu 
    const onShowContextualMenu = (item, index, ev) => {
        ev.preventDefault();

        updateContextMenuForwardRules();
        setShowContextualMenu(true);
        setContextMenuPosition(ev);

    };

    const updateContextMenuForwardRules = () => {
        const menuItems: IContextualMenuItem[] = [];

        if (abilityBuild.can('update', 'IForwardRule')) {
            menuItems.push(
                {
                    key: 'editUser',
                    text: 'Modifica regola',
                    iconProps: { iconName: 'Edit' },
                    onClick: () => {
                        props.updateForwardRuleHandler!();
                        onHideContextualMenu();
                    }
                }
            )
        }
        if (abilityBuild.can('delete', 'IForwardRule')) {
            menuItems.push(
                {
                    key: 'deleteUser',
                    text: 'Rimuovi regola',
                    iconProps: { iconName: 'Delete' },
                    onClick: () => {
                        props.deleteForwardRuleHandler!();
                        onHideContextualMenu();
                    }
                }
            )
        }
        setContextMenuItems(menuItems);
    }

    const onHideContextualMenu = () => {
        setShowContextualMenu(false);
        setContextMenuItems(undefined);
    };

    return (
        <div className={`forward-rules-table flex flex-column position-relative`}>
            <CircleLoader loaderClass='loader-large' loading={loadingForwardRulesTable} />

            {
                forwardRulesList && forwardRulesList.length > 0
                    ? <DetailsList
                        className="with-empty-column"
                        items={forwardRulesList}
                        columns={tableColumns}
                        layoutMode={DetailsListLayoutMode.justified}
                        onRenderDetailsHeader={onRenderDetailsHeader}
                        onRenderItemColumn={onRenderItemColumn}
                        selection={props.forwardRuleSelection}
                        selectionPreservedOnEmptyClick={true}
                        selectionMode={SelectionMode.single}
                        checkboxVisibility={CheckboxVisibility.onHover}
                        onItemContextMenu={onShowContextualMenu}
                    />
                    : <Text nowrap block>Nessun regola di inoltro inserita</Text>
            }
            <ContextualMenu
                items={contextMenuItems!}
                hidden={!showContextualMenu}
                target={contextMenuPosition}
                onItemClick={onHideContextualMenu}
                onDismiss={onHideContextualMenu}
            />

        </div>

    )
}
export default ForwardRulesTable;
